export default "__VITE_ASSET__5wg$hGVm__";